import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { TokenIcon } from '../../styled';
import Button from 'shared/ui/Button';
import Wrapper from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_AGENT_TOKEN, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TokenButton = ({ onClick }) => {
  const intl = useIntl();
  const canCreate = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENT_TOKEN, PERMISSION_TYPES.READ));
  const title = intl.formatMessage({ id: 'agents.token.title' });
  return (
    <Wrapper>
      <Button variant="ghost" title={ title } ariaLabel={ title } onClick={ onClick } startIcon={ <TokenIcon /> } disabled={ !canCreate } />
    </Wrapper>
  );
};
export default TokenButton;
